<template>
  <header
    id="header"
    :class="{
      active: show_mobile_menu,
      authenticated: $store.state.userAuthenticated,
    }"
  >
    <div class="">
      <div class="df s_betwen">
        <router-link to="/" class="logo hover_op" v-if="!customLogo"
          >getsynced
        </router-link>

        <router-link to="/" class="logo hover_op" v-if="customLogo">
          <img :src="roomLogo" alt="" />
        </router-link>

        <menu :class="{ active: show_mobile_menu }">
          <router-link
            to="/features"
            class="hover_op"
            @click.native="show_mobile_menu = false"
            v-if="authenticated === false"
            >Features
          </router-link>

          <router-link
            to="/pricing"
            class="hover_op"
            @click.native="show_mobile_menu = false"
            v-if="authenticated === false"
            >Pricing
          </router-link>

          <a
            href="mailto:test@test.test"
            class="hover_op"
            @click="show_mobile_menu = false"
            v-if="authenticated === false"
          >
            <img src="@/assets/img/envelop_icon.svg" alt="" /> Contact
          </a>

          <router-link
            to="/auth/login"
            class="login hover_op l_hide xl_hide"
            @click.native="show_mobile_menu = false"
            >Log in
          </router-link>

          <router-link
            to="/pricing"
            class="colored_btn get_startde hover_op"
            @click.native="show_mobile_menu = false"
            >Get started
          </router-link>
        </menu>

        <div class="user_panel">
          <template v-if="authenticated === false">
            <router-link to="/auth/login" class="hover_op m_hide s_hide"
              >Log in
            </router-link>
            <router-link
              to="/pricing"
              class="colored_btn hover_op m_hide s_hide"
              >Get started
            </router-link>
          </template>

          <template v-if="authenticated === true">
            <router-link
              to="/user_plan"
              class="colored_btn hover_op call_upgrade"
            >
              Upgrade
            </router-link>

            <router-link to="/user_rooms" class="username hover_op"
              >{{ user.displayName }} (you)
            </router-link>

            <button
              class="avatar hover_op"
              @click="show_drop = !show_drop"
              v-click-outside="hide"
            >
              <img :src="user.photoURL" alt="" v-if="user.photoURL" />
            </button>

            <div class="nav_drop drop" :class="{ active: show_drop }">
              <router-link
                to="/user_rooms"
                @click.native="hide()"
                v-if="!isMeatting"
              >
                Account
              </router-link>

              <router-link
                to="/user_profile"
                @click.native="hide()"
                v-if="!isMeatting"
              >
                Edit Profile
              </router-link>

              <a href="/user_rooms" target="_blank" v-if="isMeatting"
                >Account</a
              >

              <a href="/user_profile" target="_blank" v-if="isMeatting"
                >Edit Profile</a
              >

              <button class="sign_out" @click="logout()">Log out</button>
            </div>
          </template>
        </div>

        <div
          class="call_modal colored_btn"
          :class="{ active: show_mobile_menu }"
          @click="show_mobile_menu = !show_mobile_menu"
          v-if="authenticated === false"
        >
          <img src="@/assets/img/mob_menu_icon.svg" alt="" class="show" />
          <img src="@/assets/img/mob_close_menu_icon.svg" alt="" class="hide" />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import ClickOutside from "vue-click-outside";
import { getAuth, signOut } from "firebase/auth";

export default {
  data() {
    return {
      show_drop: false,
      show_mobile_menu: false,
    };
  },

  computed: {
    authenticated() {
      return this.$store.state.userAuthenticated;
    },

    user() {
      return this.$store.state.user;
    },

    customLogo() {
      return false; //TODO: Get logo here
    },

    roomLogo() {
      return `${process.env.VUE_APP_BACKEND_API_URL}${this.$store.state.meeting.roomData.logo}`;
    },

    isMeatting() {
      if (this.$route.name == "Meeting") {
        return true;
      } else {
        return false;
      }
    },
  },

  updated() {
    this.$nextTick(() => {
      this.headerHeigth();
    });
  },

  methods: {
    headerHeigth() {
      const header_heigth = Math.max(
        document.getElementById("header").offsetHeight
      );

      this.$store.commit("setHeaderHeigth", header_heigth);
    },

    hide() {
      this.show_drop = false;
    },

    async logout() {
      await signOut(getAuth());
      window.location.replace("/");
      this.hide();
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>

<style lang="scss">
header {
  padding-left: 44px;
  padding-right: 44px;
  padding-top: 64px;
  z-index: 1;

  @media all and (max-width: 1150px) {
    padding-left: 0;
    padding-right: 0;
  }

  @media all and (max-width: 1020px) {
    padding-left: 0;
    padding-right: 0;
    padding-top: 16px;
  }

  @media all and (max-width: 769px) {
    padding-bottom: 16px;
    height: 32px;
  }

  .logo {
    color: #000;
    font-family: "Playfair Display", serif;
    font-size: 48px;
    font-weight: 400;
    z-index: 2;
    flex: 1 1 40%;

    img {
      max-width: 150px;
      max-height: 58px;
    }

    @media all and (max-width: 1400px) {
      flex: 1 1 auto;
    }

    @media all and (max-width: 767px) {
      font-size: 36px;
    }
  }

  menu,
  .user_panel {
    display: flex;
    align-items: center;

    @media all and (max-width: 1400px) {
      flex: 1 1 auto;
    }

    .call_upgrade {
      width: 152px;
      font-family: "Nunito Sans", sans-serif;
      font-size: 16px;

      @media all and (max-width: 1000px) {
        display: none;
      }
    }

    a {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: #000;
      font-family: "Nunito Sans", sans-serif;
      font-size: 16px;
      font-weight: 700;
      font-style: normal;
      letter-spacing: normal;
      line-height: 24px;

      img {
        width: 22px;
        margin-right: 16px;
      }

      &.colored_btn {
        color: #fc5a12;
        width: 152px;
        margin-left: 32px;
      }

      &.colored_btn.get_startde {
        display: none;
      }

      &.username {
        margin-left: 32px;
        white-space: nowrap;

        @media all and (max-width: 767px) {
          display: none;
        }
      }

      & + a {
        margin-left: 64px;
      }
    }

    .avatar {
      margin-left: 32px;
      font-weight: 700;
      line-height: 24px;
    }

    .nav_drop {
      z-index: 2;
      top: 64px;
      width: 420px;
      right: 0;
      max-width: 80vw;

      @media all and (max-width: 767px) {
        top: 48px;
        max-width: calc(100vw - 32px);
        right: 0;
      }

      a {
        font-weight: 400;
        justify-content: flex-start;

        & + a {
          margin-top: 16px;
          margin-left: 0;
        }
      }

      .sign_out {
        font-weight: 400;
        margin-top: 32px;
      }
    }
  }

  .user_panel {
    flex: 1 1 40%;
    justify-content: flex-end;
  }

  menu {
    @media all and (max-width: 1100px) {
      justify-content: center;

      a {
        & + a {
          margin-left: 16px;
        }
      }
    }
    @media all and (max-width: 1000px) {
      opacity: 0;
      display: block;
      pointer-events: none;
      transition: opacity 180ms;
      position: fixed;
      width: 100%;
      background-color: #fff;
      flex-wrap: wrap;
      top: 0;
      left: 0;
      z-index: 1;
      padding: 144px 16px 64px;

      &.active {
        opacity: 1;
        pointer-events: all;
        transition: opacity 180ms;
      }

      a {
        width: 100%;

        & + a {
          margin-left: 0;
          margin-top: 32px;
        }
      }

      .login {
        margin-top: 64px;
        margin-bottom: 32px;
        display: block;

        @media all and (max-width: 1000px) {
          text-align: center;
        }
      }

      .colored_btn.get_startde {
        width: 100%;
        align-items: center;
        justify-content: center;
        flex: 1 1 100%;
        margin-left: 0;
        display: flex !important;
      }
    }
  }

  .call_modal {
    display: none;
    z-index: 2;
    flex: none;

    img {
      width: 42px;
    }

    .hide {
      display: none;
    }

    &.active {
      .hide {
        display: block;
      }

      .show {
        display: none;
      }
    }

    @media all and (max-width: 1000px) {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 64px;
      height: 64px;
    }
  }

  &::after {
    content: "";
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 0;
    background-color: #000;
    opacity: 0;
    transition: opacity 180ms;
    pointer-events: none;
  }

  &.active {
    position: fixed;
    width: 100%;

    & + main {
      margin-top: 80px;
    }

    &::after {
      content: "";
      position: fixed;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      z-index: 0;
      background-color: #000;
      opacity: 0.32;
      transition: opacity 180ms;
      pointer-events: all;
    }
  }

  &:not(.authenticated) {
    margin-bottom: 32px;
  }

  &.authenticated {
    padding: 0;

    @media all and (max-width: 769px) {
      position: absolute;
      top: 16px;
      left: 0;
      width: 100%;

      padding-left: 1rem;
      padding-right: 1rem;
    }

    .logo {
      font-size: 24px;
    }

    .avatar {
      width: 32px;
      height: 32px;
      border-radius: 8px;
      margin-left: 16px;
    }

    .user_panel {
      a {
        &.username {
          margin-left: 16px;
        }
      }

      .call_upgrade {
        padding: 0;
        width: auto;
        background-color: transparent;
      }
    }
  }
}
</style>
